import { useSelector } from 'react-redux';
import Globals from '../store/global-selectors';

export const useSellerWallets = () => {
  return useSelector(Globals.selectSellerWallets);
};
